export const LANGUAGE_FIELDS = {
  cultures: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
  enemies: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
};

export const ENEMIES_FILTER_CONFIG = {
  key: 'enemies',
  labelKey: 'treatment-search|filters.enemies',
  field: 'treatment_enemies.enemy',
  value_field: 'id',
  label_field: 'french_name',
  languageConfig: LANGUAGE_FIELDS.enemies,
  aggregate: false,
};

export const RESEEDING_FILTER_CONFIGS = [
  {
    key: 'reseeding_cultures',
    labelKey: 'treatment-search|filters.reseeding_cultures',
    type: 'tree_select',
    endpoint: '/api/cultures/tree?show_in_customer_filter_quick_processing=true',
    value_field: 'id',
    label_field: 'french_name',
    languageConfig: LANGUAGE_FIELDS.cultures,
  },
  {
    key: 'reseeding_deadlines',
    labelKey: 'treatment-search|filters.reseeding_deadlines',
    field: 'reseeding_and_rotation_deadlines',
    value_field: 'id',
    label_field: 'formatted_duration',
    aggregate: true,
  },
];

export const HERBICIDE_FILTER_CONFIGS = [
  {
    key: 'herbicide_tolerant_variety',
    labelKey: 'treatment-search|filters.herbicide_tolerant_variety',
    field: 'herbicide_tolerant_variety',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'culture_stages',
    labelKey: 'treatment-search|filters.culture_stages',
    field: 'culture_stage',
    value_field: 'id',
    label_field: 'name',
  },
];

export const AGRONOMIC_FILTER_CONFIGS = [
  {
    key: 'commercial_products',
    labelKey: 'treatment-search|filters.commercial_products',
    field: 'treatment_products.product',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'active_substances',
    labelKey: 'treatment-search|filters.active_substances',
    field: 'treatment_products.product.active_substances.active_substance',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'pesticide_groups',
    labelKey: 'treatment-search|filters.pesticide_groups',
    field:
      'treatment_products.product.active_substances.active_substance.pesticide_group_associations.pesticide_group',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'intervention_periods',
    labelKey: 'treatment-search|filters.intervention_periods',
    field: 'intervention_period',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'culture_stages',
    labelKey: 'treatment-search|filters.culture_stages',
    field: 'culture_stage',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'organic_approval',
    labelKey: 'treatment-search|filters.organic_approval',
    field: 'treatment_products.product.is_organic_approval',
    type: 'boolean_select',
    options: [
      { value: true, label: 'treatment-search|filters.organic_approved' },
      { value: false, label: 'treatment-search|filters.not_organic_approved' },
    ],
  },
  {
    key: 'soil_types',
    labelKey: 'treatment-search|filters.soil_types',
    field: 'soil_type',
    value_field: 'id',
    label_field: 'name',
  },
  {
    key: 'intercrop_cultures',
    labelKey: 'treatment-search|filters.intercrop_cultures',
    field: 'treatment_intercroppings.intercrops',
    value_field: 'id',
    label_field: 'french_name',
  },
];

export const HEALTH_FILTER_CONFIGS = [
  {
    key: 'acute_toxicity',
    labelKey: 'treatment-search|filters.acute_toxicity',
    field: 'health.acute_toxicity_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'long_term_effects',
    labelKey: 'treatment-search|filters.long_term_effects',
    field: 'health.long_term_effect_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const ENVIRONMENT_FILTER_CONFIGS = [
  {
    key: 'fish_or_daphnia',
    labelKey: 'treatment-search|filters.aquatic_organisms',
    field: 'environment.fishes_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'birds',
    labelKey: 'treatment-search|filters.birds',
    field: 'environment.birds_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'bees',
    labelKey: 'treatment-search|filters.bees',
    field: 'environment.bees_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'persistence',
    labelKey: 'treatment-search|filters.persistence',
    field: 'environment.persistence_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'leaching_potential',
    labelKey: 'treatment-search|filters.leaching_potential',
    field: 'environment.leaching_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const EXTRA_FILTER_KEYS = [
  ENEMIES_FILTER_CONFIG.key,
  ...HERBICIDE_FILTER_CONFIGS.map((c) => c.key),
  ...RESEEDING_FILTER_CONFIGS.map((c) => c.key),
  ...AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
  ...HEALTH_FILTER_CONFIGS.map((c) => c.key),
  ...ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
].filter((key, index, arr) => arr.indexOf(key) === index);

export const DOCUMENT_TYPE = 'TreatmentDocument';
